// api extractor take issues with 'as const' for literals
// eslint-disable-next-line @typescript-eslint/prefer-as-const
export const RELEASE_DOCUMENT_TYPE: 'system.release' = 'system.release'
export const RELEASE_DOCUMENTS_PATH = '_.releases'
